import { outboxEventSchema, outboxStatsSchema, retryAllResponseSchema } from "../schemas/outbox";
import { fetchApi, fetchVoid, paginatedSchema } from "./internal";

export const outbox = {
	list: (params?: { status?: string; event_type?: string; limit?: number; offset?: number }) => {
		const search = new URLSearchParams();
		if (params?.status) search.set("status", params.status);
		if (params?.event_type) search.set("event_type", params.event_type);
		if (params?.limit) search.set("limit", String(params.limit));
		if (params?.offset) search.set("offset", String(params.offset));
		const qs = search.toString();
		return fetchApi(`/admin/outbox${qs ? `?${qs}` : ""}`, paginatedSchema(outboxEventSchema));
	},
	get: (id: string) => fetchApi(`/admin/outbox/${id}`, outboxEventSchema),
	stats: () => fetchApi("/admin/outbox/stats", outboxStatsSchema),
	retry: (id: string) => fetchVoid(`/admin/outbox/${id}/retry`, { method: "POST" }),
	retryAll: () =>
		fetchApi("/admin/outbox/retry-all", retryAllResponseSchema, {
			method: "POST",
		}),
	purge: (id: string) => fetchVoid(`/admin/outbox/${id}`, { method: "DELETE" }),
};
